import { takeEvery, all, put, select } from "redux-saga/effects";
import {
    saveClientAction,
    changeStatusCreateClientModalAction,
    uploadMappingsForCreateClient,
    changeClientSavingFlag
} from "./actions";
import {
    postClientRequest,
    getClientsRequest,
    getIndustriesRequest,
    getCategoriesRequest,
    getCountryListRequest,
    DashboardUrl
} from "@common";
import { clientForm } from "./state";
import { AppState } from "../store";
import { openNotificationAction } from "../page";
import { ClientPostData, validateEmail } from "../api";
import { FetchingState } from "rd-redux-http";
import { replace } from "react-router-redux";

export function* uploadClientMappings() {
    try {
        yield all([getIndustriesRequest.saga({}), getCategoriesRequest.saga({}), getCountryListRequest.saga({})]);
    } catch (e) {
        console.log(e);
    }
}

function* saveClient() {
    yield put(clientForm.actions.resetErrors());
    const state: AppState = yield select();
    const clientFormData = clientForm.selector(state.clientState.clientForm);

    if (!clientFormData.isValid) {
        yield put(clientForm.actions.validate());
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "Client didn't save! Validation error: Please, check your form"
            })
        );

        return;
    }

    if (!validateEmail(clientFormData.fields.email.value)) {
        yield put(clientForm.actions.validate());
        yield put(clientForm.actions.setErrors({ fields: { email: ["Please, put correct email."] } }));
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "Client didn't save! Validation error: Please, check your email"
            })
        );

        return;
    }

    if (!FetchingState.isSuccess(state.pagesState.clients)) {
        yield* getClientsRequest.saga({});
    }

    const accName = clientFormData.fields.accountName.value;
    const isNameReapeats: boolean =
        FetchingState.isSuccess(state.pagesState.clients) &&
        state.pagesState.clients.data.clients.some(c => c.name === accName);

    if (isNameReapeats) {
        yield put(clientForm.actions.validate());
        yield put(clientForm.actions.setErrors({ fields: { accountName: ["Please, choose another name."] } }));
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "This name already exists. Please, choose another name"
            })
        );

        return;
    }

    try {
        yield put(changeStatusCreateClientModalAction({ isOpen: false }));
        yield put(changeClientSavingFlag({ status: true }));

        const clientData: ClientPostData = {
            name: clientFormData.data.accountName,
            email: clientFormData.data.email,
            phone: clientFormData.data.phone,
            category: clientFormData.data.category,
            industry: clientFormData.data.industry,
            invoice: clientFormData.data.invoice,
            address: {
                "line-1": clientFormData.data.addressLine1,
                "line-2": clientFormData.data.addressLine2,
                city: clientFormData.data.city,
                province: clientFormData.data.stateOrProvince,
                postal: clientFormData.data.zipCode,
                country: clientFormData.data.country
            }
        };

        const res = yield* postClientRequest.saga({}, clientData);
        yield* getClientsRequest.saga({});

        if (res) {
            yield put(
                openNotificationAction({
                    isOpen: true,
                    message: "Client saved!"
                })
            );
            yield put(changeClientSavingFlag({ status: false }));

            yield put(replace(DashboardUrl.format({ clientId: res.client.client["client-id"] })));
        }
    } catch (e) {
        console.log(e);
        yield put(
            openNotificationAction({
                isOpen: true,
                isWarning: true,
                message: "Client didn't save! Please, try later"
            })
        );
        yield put(changeClientSavingFlag({ status: false }));
    }
}

export function* clientSaga() {
    yield all([
        takeEvery(uploadMappingsForCreateClient.type, uploadClientMappings),
        takeEvery(saveClientAction.type, saveClient)
    ]);
}
